import { Component, inject, input, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxTooltipDirective } from '../../../directives/onyx-tooltip.directive';
import { OverflowHelper } from '../../../helpers';
import { I18N_NAMESPACE } from '../../../internal/constants';
import { OnyxButtonComponent } from '../../buttons/onyx-button/onyx-button.component';
import { OnyxCloseButtonComponent } from '../../buttons/onyx-close-button/onyx-close-button.component';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import type { OnyxTooltipContext } from '../../tooltip/interfaces';
import type { OnyxMessageType } from '../enums';

@Component({
  selector: 'onyx-message',
  imports: [
    OnyxCloseButtonComponent,
    OnyxTooltipDirective,
    OnyxIconComponent,
    OnyxButtonComponent,
    TranslatePipe,
  ],
  templateUrl: './onyx-message.component.html',
  styleUrl: './onyx-message.component.scss',
})
export class OnyxMessageComponent {
  protected readonly overflowHelper = inject(OverflowHelper);

  public readonly intent = input.required<`${OnyxMessageType}`>();
  public readonly showClose = input(false);
  public readonly tooltip = input<OnyxTooltipContext | null>(null);
  public readonly showExpandButton = input(false);
  public readonly clickable = input(false);
  public readonly closeMessage = output<void>();
  public readonly redirect = output<void>();

  protected readonly I18N = `${I18N_NAMESPACE}.common`;

  protected isExpanded = signal(false);
}
